import { render, staticRenderFns } from "./ConsultantReview.vue?vue&type=template&id=3a5befc0&"
import script from "./ConsultantReview.vue?vue&type=script&lang=js&"
export * from "./ConsultantReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports